import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../Firebase/Firebase';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import './search.css';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import LoadingScreen from '../Components/loading';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

function TiposEspacios() {
    const { IdEspacios } = useParams();
    const [espaciosData, setEspaciosData] = useState([]);
    const [nombreTipoEspacio, setNombreTipoEspacio] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentSlide, setCurrentSlide] = useState(0);
    const [tipoEspaciosList, setTipoEspaciosList] = useState([]); // Lista de tipos de espacios
    const [selectedTipoEspacio, setSelectedTipoEspacio] = useState(IdEspacios || '');
    const [contadorEspacios, setContadorEspacios] = useState(0);

    const navigate = useNavigate();

    // Obtener lista de tipos de espacios
    const fetchTiposEspacios = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'tipoespacio'));
            const tiposArray = querySnapshot.docs.map(doc => ({
                id: doc.id,
                nombre: doc.data().TipoEspacio,
            }));
            setTipoEspaciosList(tiposArray);
        } catch (err) {
            console.error('Error al obtener tipos de espacios:', err);
        }
    };

    // Obtener el nombre del tipo de espacio seleccionado
    const fetchNombreTipoEspacio = async () => {
        try {
            const docRef = doc(db, 'tipoespacio', selectedTipoEspacio);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setNombreTipoEspacio(docSnap.data().TipoEspacio);
            } else {
                setNombreTipoEspacio('Tipo de Espacio Desconocido');
            }
        } catch (err) {
            console.error('Error al obtener el nombre del tipo de espacio:', err);
            setNombreTipoEspacio('Error al cargar el nombre del tipo de espacio');
        }
    };

    // Obtener los datos de espacios según el tipo seleccionado
    const fetchData = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(db, 'espacios'),
                where('TipoEspacio', '==', selectedTipoEspacio)
            );

            const querySnapshot = await getDocs(q);
            const espaciosArray = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            setEspaciosData(espaciosArray);
            setContadorEspacios(espaciosArray.length); // Actualiza el contador

        } catch (err) {
            setError('Error al cargar los datos');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTiposEspacios(); // Obtener lista de tipos de espacios al cargar el componente
    }, []);

    useEffect(() => {
        if (selectedTipoEspacio) {
            fetchNombreTipoEspacio(); // Obtener nombre del tipo de espacio
            fetchData(); // Obtener datos de los espacios
        }
    }, [selectedTipoEspacio]);

    if (loading) {
        return <LoadingScreen></LoadingScreen>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    const handleReservar = (idEspacio) => {
        navigate(`/office/${idEspacio}`);
    };

    // Avanzar a la siguiente slide
    const nextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % espaciosData.length);
    };

    // Retroceder a la slide anterior
    const prevSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex - 1 + espaciosData.length) % espaciosData.length);
    };

    // Cambiar tipo de espacio
    const handleTipoEspacioChange = (event) => {
        setSelectedTipoEspacio(event.target.value);
        setCurrentSlide(0); // Reiniciar el slider al cambiar el tipo
    };

    return (
        <div>
            <Navbar  />
            <NavbarMobileVersion  />
            <div className="resultados-container" style={{ marginTop: '50px' }}>
                <div className="resultados-header">
                    <h1>Espacios Disponibles: </h1>

                    <select className="select_tipo_es" value={selectedTipoEspacio} onChange={handleTipoEspacioChange}>
                        <option value=""></option>
                        {tipoEspaciosList.map((tipo) => (
                            <option key={tipo.id} value={tipo.id}>
                                {tipo.nombre}
                            </option>
                        ))}
                    </select>
                </div>


                <h1>{nombreTipoEspacio}</h1>

                <div className="espacios-slider">
                    <button className="prev-btn-tp-es" onClick={prevSlide}>❮</button>
                    {espaciosData.length > 0 && (
                        <div key={espaciosData[currentSlide].id} className="espacio-card">
                            {espaciosData[currentSlide].Imagenes && espaciosData[currentSlide].Imagenes[0] && (
                                <img
                                    src={espaciosData[currentSlide].Imagenes[0]}
                                    alt={espaciosData[currentSlide].NombreEspacio}
                                />
                            )}
                            <h3>{espaciosData[currentSlide].NombreEspacio}</h3>
                            <button
                                onClick={() => handleReservar(espaciosData[currentSlide].id)}
                                className="reservar-btn"
                            >
                                Confirmar Reserva
                            </button>
                            <h4>Espacio {espaciosData.length > 0 ? currentSlide + 1 : 0} de {espaciosData.length} </h4>

                        </div>
                    )}
                    <button className="next-btn-tp-es" onClick={nextSlide}>❯</button>
                </div>

            </div>
        </div>
    );
}

export default TiposEspacios;
